import React from 'react';
import './KippyEmotions.css';


const EMOTION_CONFIG = {
  neutral: {
    src: '../kippy-neutral.png',
    alt: 'Kippy looking calm and neutral',
    animationClass: 'kippy-anim-float',
  },
  happy: {
    src: '../kippy-happy.png',
    alt: 'Kippy looking happy',
    animationClass: 'kippy-anim-bounce',
  },
  'super-happy': {
    src: '../kippy-super-happy.png',
    alt: 'Kippy celebrating super happily!',
    animationClass: 'kippy-anim-wiggle-bounce',
  },
  sad: {
    src: '../kippy-sad.png',
    alt: 'Kippy feeling a bit sad',
    animationClass: 'kippy-anim-droop',
  },
  'super-sad': {
    src: '../kippy-super-sad.png',
    alt: 'Kippy looking very sad and crying',
    animationClass: 'kippy-anim-shiver',
  },
};

/**
 * @param {string} emotion - 'neutral' | 'happy' | 'super-happy' | 'sad' | 'super-sad'
 * @param {number|string} size - CSS size for width/height (default: 160px)
 * @param {string} className - Optional external styling class
 * @param {function} onClick - Optional click handler
 */
export default function KippyEmotions({
  emotion = 'neutral',
  size = 160,
  className = '',
  onClick,
}) {
  const normalizedEmotion = EMOTION_CONFIG[emotion] ? emotion : 'neutral';
  const config = EMOTION_CONFIG[normalizedEmotion];

  return (
    <div
      className={`kippy-emotions kippy-emotions--${normalizedEmotion} ${className}`}
      style={{ '--kippy-size': typeof size === 'number' ? `${size}px` : size }}
      onClick={onClick}
      role="img"
      aria-label={config.alt}
    >
      {/* Ground Contact Shadow */}
      <div className="kippy-emotions__shadow" />

      {/* Animated Mascot Layer */}
      <div className={`kippy-emotions__character ${config.animationClass}`}>
        <img
          key={normalizedEmotion}
          src={config.src}
          alt={config.alt}
          className="kippy-emotions__image"
          draggable={false}
        />
      </div>
    </div>
  );
}